import { actions as actions$1 } from '@grandvisionhq/state';

const idPayload = actions$1.payload();
const startConfigurator = actions$1.action('configurator/start', actions$1.payload());
const isStartConfiguratorWithId = (id)=>(a)=>actions$1.isType(a, startConfigurator) && a.payload.id === id
;
/**
 * Stepping actions
 */ const nextStep = actions$1.action('configurator/next-step', idPayload);
const isNextStepWithId = (id)=>(a)=>actions$1.isType(a, nextStep) && a.payload.id === id
;
const nextStepSuccess = actions$1.action('configurator/next-step-success', actions$1.payload());
const isNextStepSuccessWithId = (id)=>(a)=>actions$1.isType(a, nextStepSuccess) && a.payload.id === id
;
const nextStepFailed = actions$1.action('configurator/next-step-failed', actions$1.payload());
const isNextStepFailedWithId = (id)=>(a)=>actions$1.isType(a, nextStepFailed) && a.payload.id === id
;
const previousStep = actions$1.action('configurator/previous-step', idPayload);
const isPreviousStepWithId = (id)=>(a)=>actions$1.isType(a, previousStep) && a.payload.id === id
;
const previousStepFailed = actions$1.action('configurator/previous-step-failed', actions$1.payload());
const isPreviousStepFailedWithId = (id)=>(a)=>actions$1.isType(a, previousStepFailed) && a.payload.id === id
;
const previousStepSuccess = actions$1.action('configurator/previous-step-success', actions$1.payload());
const isPreviousStepSuccessWithId = (id)=>(a)=>actions$1.isType(a, previousStepSuccess) && a.payload.id === id
;
/**
 * Footer actions
 */ const toggleFooter = actions$1.action('configurator/footer/toggle', idPayload);
const isToggleFooterWithId = (id)=>(a)=>actions$1.isType(a, toggleFooter) && a.payload.id === id
;
const openFooter = actions$1.action('configurator/footer/open', idPayload);
const isOpenFooterWithId = (id)=>(a)=>actions$1.isType(a, openFooter) && a.payload.id === id
;
const closeFooter = actions$1.action('configurator/footer/close', idPayload);
const isCloseFooterWithId = (id)=>(a)=>actions$1.isType(a, closeFooter) && a.payload.id === id
;
const stepShown = actions$1.action('configurator/step-shown', actions$1.payload());
const isStepShownWithId = (id)=>(a)=>actions$1.isType(a, stepShown) && a.payload.id === id
;
const finish = actions$1.action('configurator/finish', actions$1.payload());
const isFinishWithId = (id)=>(a)=>actions$1.isType(a, finish) && a.payload.id === id
;
const finishFailed = actions$1.action('configurator/finish-failed', actions$1.payload());
const finishSuccess = actions$1.action('configurator/finish-success', actions$1.payload());

export { closeFooter, finish, finishFailed, finishSuccess, isCloseFooterWithId, isFinishWithId, isNextStepFailedWithId, isNextStepSuccessWithId, isNextStepWithId, isOpenFooterWithId, isPreviousStepFailedWithId, isPreviousStepSuccessWithId, isPreviousStepWithId, isStartConfiguratorWithId, isStepShownWithId, isToggleFooterWithId, nextStep, nextStepFailed, nextStepSuccess, openFooter, previousStep, previousStepFailed, previousStepSuccess, startConfigurator, stepShown, toggleFooter };
//# sourceMappingURL=actions.js.map
